import { Button, Popover } from "@jelly/ui";
import classnames from "classnames";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../../components/Layout/Layout";

import useCourseWelcomeController from "../../controllers/useCourseWelcomeController";

import styles from "./CourseWelcome.module.scss";
import CourseWelcomeAuthorsList from "./views/AuthorsList.view";
import CourseWelcomeIntroView from "./views/Intro.view";

interface CourseWelcomePageParams {
  courseId: string;
}

const CourseWelcomePage: React.FC = () => {
  const { courseId } = useParams<CourseWelcomePageParams>();
  const { course, chapters, firstLesson } = useCourseWelcomeController(courseId);
  const [currentViewIndex, setCurrentViewIndex] = useState<number>(0);

  if (!course || !chapters || !firstLesson) {
    return null;
  }

  const views = [
    <CourseWelcomeIntroView
      key={0}
      course={course}
      courseId={courseId}
      firstLesson={firstLesson}
      chapters={chapters}
    />,
    <CourseWelcomeAuthorsList course={course} key={1} />,
  ];

  const nextView = views[currentViewIndex + 1] !== undefined ? currentViewIndex + 1 : -1;
  const prevView = views[currentViewIndex - 1] !== undefined ? currentViewIndex - 1 : -1;

  return (
    <Layout>
      <div className={styles.root}>
        <main>
          <div className={styles.view}>{views[currentViewIndex]}</div>
          {views.length > 1 && (
            <div className={styles.navigation}>
              <div className={classnames(styles.prevButton, { [styles.hidden]: prevView === -1 })}>
                <Button
                  shape="round"
                  theme={"secondary"}
                  icon={"cil-arrow-left"}
                  iconPlacement={"left"}
                  onClick={() => setCurrentViewIndex(prevView)}
                >
                  Previous
                </Button>
              </div>
              <div className={styles.breadcrumbs}>
                {views.map((_, index) => (
                  <Popover key={index} subTxt={`${index + 1}/${views.length}`}>
                    <div
                      key={index}
                      className={classnames(styles.dot, { [styles.active]: index === currentViewIndex })}
                      onClick={() => setCurrentViewIndex(index)}
                    />
                  </Popover>
                ))}
              </div>
              <div className={classnames(styles.nextButton, { [styles.hidden]: nextView === -1 })}>
                <Button
                  shape="round"
                  theme={"secondary"}
                  icon={"cil-arrow-right"}
                  iconPlacement={"right"}
                  disabled={nextView === -1}
                  onClick={() => setCurrentViewIndex(nextView)}
                >
                  Next
                </Button>
              </div>
            </div>
          )}
        </main>
      </div>
    </Layout>
  );
};

export default CourseWelcomePage;
